import PropTypes from 'prop-types';
import React from 'react';
import { formatHorseAge, distanceFormat } from 'modules/HorseRacing/utils';

export default function RaceSummaryText(props) {
  const {
    distance: raceDistance,
    race_class: raceClass,
    age: age,
    ride_count: rideCount
  } = props.raceSummary;

  return (
    <span>({[formatHorseAge(age), raceClass && 'Class '+raceClass, distanceFormat(raceDistance), rideCount+' runners'].filter(x => !!x).join(', ')})</span>
  )
}

RaceSummaryText.propTypes = {
  raceSummary: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./modules/Common/components/RaceSummaryText.js